import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from "@angular/core";
import { ApiConfiguration } from "../chardi-proxy-api/api-configuration";
import { environment } from "../../../environments/environment";
import { ChardiApiConfiguration } from "../models/chardi-api-configuration.model";
import { ApiModule } from "../chardi-proxy-api/api.module";

export function provideChardiApiWithInterceptor(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const url = environment.chardiProxyUrl;
        const apiConfiguration = new ApiConfiguration();
        apiConfiguration.rootUrl = url;
        return apiConfiguration;
      }
    },
    {
      provide: ChardiApiConfiguration,
      useFactory: () => {
        const username = environment.chardiUsername;
        const password = environment.chardiPassword;
        const chardiApiConfiguration = new ChardiApiConfiguration();
        chardiApiConfiguration.username = username;
        chardiApiConfiguration.password = password;
        return chardiApiConfiguration;
      }
    },
     importProvidersFrom(ApiModule.forRoot({
      rootUrl: environment.chardiProxyUrl
     }))
  ]);
}